module.exports = __webpack_public_path__ + "media/images/cplook/cc-amex-45115af14c2ac36345b1d7767b810ea6.gif";